import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {graniteGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  icons: {
    position: 'absolute' as const,
    top: indent * 0.75,
    right: 0,
    maxWidth: '100%' as const,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
  },
  icon: {
    fontSize: 26,
    color: graniteGray,
  },
  base: {
    flex: 1,
    maxWidth: '100%' as const,
    width: '100%' as const,
    overflow: 'hidden' as const,
  },
});
